import classNames from "classnames/bind";
import styles from "./ConfigVariable.module.css";
import { useContext, useEffect, useState } from "react";
// import { LisencePlateManagerContext } from "../../../../../contexts";
import { aiConfigFRS } from "../../../../../services/api/aiConfigFRS";
import FormParamAiConfig from "./FormParamAiConfig";
import { Alert, Button, Loading, Toast } from "../../../../../components";
import { schedules } from "./ConfigSchedule";
import { checkTimeHouse, listParamLevelTranslate } from "../../../../../utils";
import { useTranslation } from "react-i18next";
import { aiConfigService } from "../../../../../services/api/aiConfigService";

const cx = classNames.bind(styles);
function ConfigVariable({ cameraCode, ...props }) {
    // const { cameraCode } = useContext(LisencePlateManagerContext);
    const { onClose, statusAi, companyOfCam, isChanged, setIsChanged } = props;
    const [listParam, setListParam] = useState([]);
    const [listSchedule, setListSchedule] = useState([]);
    const [valueConfig, setValueConfig] = useState({
        time_start: '00:00',
        time_end: '23:59'
    });
    const [reFresh, setReFresh] = useState(false);
    const [loading, setLoading] = useState(true);
    const [schedulesApi, setSchedulesApi] = useState([]);
    const [confirmDefault, setConfirmDefault] = useState(false);
    const [timeKeepingEventMax, setTimeKeepingEventMax] = useState(1);
    const { t } = useTranslation();
    // Lấy danh sách cấu hình đã có hoặc mặc định của cam chưa có mô tả
    const getConfigByCameraCode = async () => {
        try {
            const res = await aiConfigFRS.getListAiConfigByIdCam(cameraCode)
            if (res) {
                res?.forEach(element => {
                    setValueConfig(prev => ({ ...prev, [element?.param]: element?.aiParamLevelId }))
                });
            }
        } catch (error) {
            return 0;
        }
    }

    const getvalueConfig = (listParamConfig) => {
        const listParam = listParamConfig?.map(pcf => {
            const options = pcf?.aiParamLevels?.map(apl => {
                return {
                    label: listParamLevelTranslate?.find(item => item?.param_name === apl?.paramLevel)?.name_tr || apl?.paramLevel,
                    value: apl?.id
                }
            })
            return {
                type: 'select',
                label: pcf?.description,
                options: options,
                param: pcf?.param
            }
        })
        setListParam(listParam)
    }
    // lấy danh sách các chức năng thoogn báo cho ai
    const getListLableSchedule = (scheduleApi, timeClean) => {
        const schedulesAddValue = schedules.map(item => {
            switch (item?.param) {
                case 'TIME_ACTIVE':
                    setValueConfig(prev => ({ ...prev, time_start: scheduleApi?.TIME_START, time_end: scheduleApi?.TIME_END }))
                    return {
                        ...item,
                        param: item?.param?.toLocaleLowerCase(),
                        type: 'time'
                    }
                case 'TIME_KEEPING_EVENT':
                    setValueConfig(prev => ({ ...prev, [item?.param?.toLocaleLowerCase()]: timeClean?.TIME_KEEPING || null }));
                    return {
                        ...item,
                        param: item?.param?.toLocaleLowerCase(),
                        type: 'input'
                    }
                default:
                    setValueConfig(prev => ({ ...prev, [item?.param?.toLocaleLowerCase()]: scheduleApi[item?.param] }))
                    return {
                        ...item,
                        param: item?.param?.toLocaleLowerCase(),
                        type: 'switch'
                    }
            }
        })
        setListSchedule(schedulesAddValue);
    }

    const getListSchedule = async () => {
        try {
            const param = {
                camera_code: cameraCode,
                ai_service_code: "20230222000000000002",
            }
            const res = await aiConfigFRS.getListSchedule(param)
            const timeClean = await aiConfigService.getDefaultConfig(cameraCode);
            setTimeKeepingEventMax(timeClean?.TIME_KEEPING_DEFAULT || 1);
            if (res) {
                getListLableSchedule(res, timeClean)
                setSchedulesApi(Object.entries(res))
            }
        } catch (error) {
            throw error;
        }
    }

    // Lấy danh sách các thông số cấu hình có đầy đủ thông tin của một thông số cấu hình, sẽ hiện ra màn hình
    const getListParamConfig = async () => {
        try {
            const res = await aiConfigFRS.getListAiParams()
            getvalueConfig(res)
        } catch (error) {
            return 0;
        }
    }


    useEffect(() => {
        const getAllInfo = async () => {
            try {
                await getListSchedule()
                await getListParamConfig()
                await getConfigByCameraCode()
                setLoading(false)
            } catch (error) {
                setLoading(false)
                Toast.open("Lấy cấu hình không thành công", 'danger')
                // console.log("getAllInfo", error);
            }
        }
        getAllInfo()
    }, [cameraCode, reFresh])

    const handleChangeValue = (key, value) => {
        if (key === 'time_keeping_event' && value > timeKeepingEventMax) {
            Toast.open(`Số ngày lưu lại lớn hơn số ngày mặc định`, 'danger');
            return;
        }
        setValueConfig(prev => ({ ...prev, [key]: value }));
    }

    const handleShowConfirmDefault = () => {
        setConfirmDefault(!confirmDefault)
    }


    const handleSetDefault = async () => {
        setLoading(true)
        handleShowConfirmDefault()
        try {
            await aiConfigFRS.setDefaultConfig(cameraCode)
            Toast.open("Cài lại mặc định Nhận dạng khuôn mặt thành công", 'success')
            setReFresh(!reFresh)
        } catch (error) {
            setLoading(false)
            Toast.open("Cài lại mặc định Nhận dạng khuôn mặt không thành công", 'danger')
        }
    }

    const handleCancel = () => {
        setLoading(true)
        setReFresh(!reFresh)
        if (onClose) {
            onClose();
        }
    }

    const handleFilterConfig = (valueCf) => {
        const infoParamConfig = Object.entries(valueCf)?.filter(([key, value]) => listParam?.find(it => it?.param === key) ? 1 : 0);
        const infoSchaduleConfig = Object.entries(valueCf)?.filter(([key, value]) => schedulesApi?.find(([k, val]) => k.toLocaleLowerCase() === key) ? 1 : 0);
        const cleanEvent = Object.entries(valueCf)?.filter(([key, value]) => key === 'time_keeping_event');
        return { infoParamConfig, infoSchaduleConfig, cleanEvent }
    }
    const handleTurnOn = async () => {
        setLoading(true)
        try {
            const allInfoConfig = handleFilterConfig(valueConfig)
            const listConfig = allInfoConfig?.infoParamConfig?.map(([key, value]) => value)
            const infoConfig = {
                cameraCode: cameraCode,
                aiParamsLevelIds: listConfig,
                serviceCode: "20230222000000000002",
                companyCode: companyOfCam?.company_code || "",
                companyName: companyOfCam?.company_name || "",
            }
            const configSchedule = {
                ai_param_level_code: {
                    code: [29, 30]
                },
                ai_service_code: "20230222000000000002",
                camera_code: cameraCode,
            }
            const cleanEvent = {
                cameraid: cameraCode,
                time_keeping: allInfoConfig?.cleanEvent.map(([key, value]) => value)[0]
            }
            allInfoConfig?.infoSchaduleConfig?.forEach(([key, val]) => {
                configSchedule[key] = val
            })
            await aiConfigFRS.postAddAiConfig(configSchedule)
            await aiConfigFRS.editConfig(infoConfig)
            await aiConfigService.configAi(cleanEvent)
            if (isChanged) {
                Toast.open("Bật Nhận dạng khuôn mặt thành công", 'success')
            } else {
                Toast.open("Cài đặt Nhận dạng khuôn mặt thành công", 'success')
            }
            setLoading(false)
            setIsChanged(false)
        } catch (error) {
            if (isChanged) {
                if (error?.response?.data?.message && error?.response?.data?.message?.search("403") >= 0) {
                    Toast.open("Không có quyền bật Nhận dạng khuôn mặt", 'danger')
                } else {
                    Toast.open("Bật Nhận dạng khuôn mặt không thành công", 'danger')
                }
            } else {
                Toast.open("Cài đặt Nhận dạng khuôn mặt không thành công", 'danger')
            }
            setLoading(false)
        }
    }

    const handleTurnOff = async () => {
        setLoading(true)
        try {
            const param = {
                camera_code: cameraCode,
                ai_service_code: "20230222000000000002"
            }
            await aiConfigFRS.deleteConfig(param)
            Toast.open("Tắt Nhận dạng khuôn mặt thành công", 'success')
            setLoading(false)
            setIsChanged(false)
        } catch (error) {
            setLoading(false)
            if (isChanged) {
                if (error?.response?.data?.message && error?.response?.data?.message?.search("403") >= 0) {
                    Toast.open("Không có quyền tắt Nhận dạng khuôn mặt", 'danger')
                } else {
                    Toast.open("Tắt Nhận dạng khuôn mặt không thành công", 'danger')
                }
            } else {
                Toast.open("Cài đặt Nhận dạng khuôn mặt không thành công", 'danger')
            }
        }
    }

    const handleAccept = () => {
        if (!checkTimeHouse(valueConfig.time_start, valueConfig.time_end)) {
            if (statusAi) {
                handleTurnOn()
            } else {
                handleTurnOff()
            }
        }
        else {
            Toast.open("Giờ bắt đầu phải nhỏ hơn giờ kết thúc", "danger")
        }
    }

    return (
        <>
            {confirmDefault && <Alert title={t('setting.Confirm_reset_to_default')}
                onClose={handleShowConfirmDefault}
                onOk={handleSetDefault}
            />}
            <FormParamAiConfig
                value={valueConfig}
                onChange={handleChangeValue}
                listParamConfig={[...listSchedule, ...listParam]}
            />
            <div className={cx('footer')}>
                <Button
                    title={t('setting.Reset_to_default')}
                    className={cx("btn-save")}
                    onClick={handleShowConfirmDefault}
                />
                <Button
                    title={t('stream.cancelCustom')}
                    className={cx("btn-cancle")}
                    onClick={handleCancel}
                />
                <Button
                    title={t('settingCam.Save_settings')}
                    className={cx("btn-save")}
                    onClick={handleAccept}
                />
            </div>
            {loading && <div className={cx('modal_loading')}><Loading /></div>}
        </>
    )
}

export default ConfigVariable;